<app-toolbar></app-toolbar>
<app-header [title]="title">
  <markant-button class="link" [routerLink]="routes.welcome" [routerLinkActive]="'primary'" [colorScheme]="pickedUrl('Übersicht')"> Übersicht </markant-button>

  <markant-button class="link" [routerLink]="routes.profile" [routerLinkActive]="'primary'" [colorScheme]="pickedUrl('Profil')"> Profil </markant-button>

  <markant-button class="link" [routerLink]="routes.product" [routerLinkActive]="'primary'" [colorScheme]="pickedUrl('Produkt')"> Produkt </markant-button>

  <markant-button class="link" [routerLink]="routes.preview" [routerLinkActive]="'primary'" [colorScheme]="pickedUrl('Vorschau')"> Vorschau </markant-button>
</app-header>
<router-outlet style="outline: 1px solid blue"></router-outlet>
<freshdesk-support></freshdesk-support>
